import loginBackground from "../../assets/loginBackground.jpg";

const UnityMenu = () => {

  const currentUrl = window.location.origin + window.location.pathname;
  const baseUrl = currentUrl.replace(/\/3d-dashboard$/, '');
  const encodedUrl = encodeURIComponent(baseUrl);

  return (
    <div className="w-full h-full">
      <div className="absolute w-full h-full top-0 left-0">
        <img src={loginBackground} className="w-full h-full absolute opacity-35"></img>
        <div className="absolute h-full w-full flex justify-center items-center">
          <div className="w-max max-w-[40vw] h-max bg-black p-4 rounded-xl flex flex-wrap gap-10">
            <h3 className="max-w-[40vw]">
              To work with scan results and to use all available features and benefits of digital twin technology, install the ProcessHub desktop application on your computer. To download the installation file, follow the link. If the app is already installed on your machine, press the <span className="font-bold">Open In App</span> button.
            </h3>
            <div className="flex gap-6 items-center justify-center w-full">
              <button className="btn">
                <a href={`progressmonitoring://open?url=${encodedUrl}`}>
                  Open In App
                </a>
              </button>
              <a className="btn" href="https://next-era-api.processhub.ai/files/progressmonitoring.exe">Download Installer</a>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default UnityMenu;